export default __webpack_public_path__ + "static/media/Active_circle.18378349.svg";